export default {
  // <div dangerouslySetInnerHTML={{ __html: lang.ruleContent }}></div>
  en: {
    nogold: 'Not enough gold coins',
    networkout: 'The network timed out, please go to the history to check the result!',
    rank: 'Ranking',
    history: 'History Record',
    rule: 'Rules',
    round: 'Round',
    winfruit: 'Winning Gem',
    selfruit: 'Selected Gem',
    goldNum: 'Betting Gem',
    gain: 'Obtained Gem',
    ruleContent:
      "1. The user chooses one of the 5 gems to bet<br/>2. The user who guesses the gem correctly will get 90%of the total betting gold coins in this round<br/>3. If multiple users guess the gems at the same time, 90% of all the gold coins will be divided according to the proportion of the gold coins bet<br/>4. If only 1 user participates in the game, the current round of the game is invalid, and the user's original bet amount of gold coins will be returned, ranking points are not counted.",
    invalid: 'Single bet is invalid, 11 gold coins have been returned',
    gainGold: 'You get 。。。<img src="/img/activity/lottery/jb.png"> gold coins in this round',
    ok: 'OK'
  },
  ar: {
    nogold: 'عملات ذهبية غير كافية',
    networkout: 'انتهت مهلة الشبكة ، يرجى الانتقال إلى السجل للتحقق من النتيجة',
    rank: 'الترتيب',
    history: 'التاريخ',
    rule: 'القاعدة',
    round: 'الجولة',
    winfruit: 'الجوهرة الفائزة',
    selfruit: 'أحجار كريمة مختارة',
    goldNum: 'العملات الذهبية للمراهنة',
    gain: 'الحصول على العملات الذهبية',
    ruleContent:
      '١ ، يختار المستخدم واحدة من الجواهر الخمسة للمراهنة<br/>٢، سيحصل المستخدم الذي يخمن الأحجار الكريمة بشكل صحيح على ٩٠٪ من إجمالي العملات الذهبية التي تراهن في هذه الجولة<br/>٣ ، إذا خمن العديد من المستخدمين الأحجار الكريمة في نفس الوقت ، فسيتم تقسيم ٩٠٪ من جميع العملات الذهبية وفقًا لنسبة الرهان على العملات الذهبية<br/>٤ ،  إذا شارك مستخدم واحد فقط في اللعبة ، فإن الجولة الحالية من اللعبة غير صالحة ، وسيتم إرجاع مبلغ الرهان الأصلي للمستخدم من العملات الذهبية ، لا يتم احتساب نقاط الترتيب',
    invalid: 'الرهان الفردي غير صالح ، تم إرجاع عملات ذهبية11 ',
    gainGold: 'تحصل على 。。。<img src="/img/activity/lottery/jb.png"> عملات ذهبية في هذه الجولة',
    ok: 'موافق',
  },
  tr: {
    nogold: 'Altın yetersiz',
    networkout: 'Ağ zaman aşımına uğradı, sonucu kontrol etmek için lütfen geçmişe gidin!',
    rank: 'rütbe',
    history: 'tarih kaydı',
    rule: 'kural',
    round: 'yuvarlak',
    winfruit: 'kazanan mücevher',
    selfruit: 'seçilmiş mücevher',
    goldNum: 'bahsin mücevheri',
    gain: 'Elde edilen tüm altın paralar',
    ruleContent:
      "1. Kullanıcı bahis yapmak için 5 mücevherden birini seçer<br/>2. Mücevheri doğru tahmin eden kullanıcı bu turda toplam bahis altın jetonlarının %90'ını alacaktır<br/>3. Aynı anda değerli taşlar, tüm altın paraların %90'ı altın para bahsinin oranına göre bölünecektir<br/>4. Oyuna sadece 1 kullanıcı katılırsa, oyunun mevcut turu geçersizdir ve kullanıcının orijinal bahis miktarı olan altın para iade edilir, sıralama puanları sayılmaz.",
    invalid: 'Tekli bahis geçersiz, 11 altın iade edildi',
    gainGold: 'Bu turda 。。。<img src="/img/activity/lottery/jb.png"> altın alırsın',
    ok: 'tamam'
  },
  pt:{
    "nogold": "Moedas de ouro insuficientes",
    "networkout": "A rede expirou, por favor, vá para o histórico para verificar o resultado!",
    "rank": "Classificação",
    "history": "Registro de Histórico",
    "rule": "Regras",
    "round": "Rodada",
    "winfruit": "Gema Vencedora",
    "selfruit": "Gema Selecionada",
    "goldNum": "Gema Apostada",
    "gain": "Gema Obtida",
    "ruleContent":
        "1. O usuário escolhe uma das 5 gemas para apostar<br/>" +
        "2. O usuário que adivinhar a gema corretamente receberá 90% do total de moedas de ouro apostadas nesta rodada<br/>" +
        "3. Se vários usuários adivinharem as gemas ao mesmo tempo, 90% de todas as moedas de ouro serão divididas de acordo com a proporção das moedas apostadas<br/>" +
        "4. Se apenas 1 usuário participar do jogo, a rodada atual do jogo será inválida, e a quantidade original de moedas apostadas será devolvida, os pontos de classificação não serão contados.",
    "invalid": "Aposta única é inválida, 11 moedas de ouro foram devolvidas",
    "gainGold": "Você obteve ...<img src='/img/activity/lottery/jb.png'> moedas de ouro nesta rodada",
    "ok": "OK"
    },
  id:{
    "nogold": "Koin emas tidak cukup",
    "networkout": "Jaringan telah habis waktu, silakan periksa hasil di riwayat!",
    "rank": "Peringkat",
    "history": "Rekam Jejak Sejarah",
    "rule": "Aturan",
    "round": "Putaran",
    "winfruit": "Permata Pemenang",
    "selfruit": "Permata Terpilih",
    "goldNum": "Permata Taruhan",
    "gain": "Permata Diperoleh",
    "ruleContent":
        "1. Pengguna memilih salah satu dari 5 permata untuk dipertaruhkan<br/>" +
        "2. Pengguna yang menebak permata dengan benar akan mendapatkan 90% dari total koin emas yang dipertaruhkan di putaran ini<br/>" +
        "3. Jika beberapa pengguna menebak permata pada waktu yang sama, 90% dari semua koin emas akan dibagi berdasarkan proporsi koin emas yang dipertaruhkan<br/>" +
        "4. Jika hanya 1 pengguna yang berpartisipasi dalam permainan, putaran permainan ini dianggap tidak sah, dan jumlah koin emas taruhan asli pengguna akan dikembalikan, poin peringkat tidak dihitung.",
    "invalid": "Taruhan tunggal tidak sah, 11 koin emas telah dikembalikan",
    "gainGold": "Anda mendapatkan ...<img src='/img/activity/lottery/jb.png'> koin emas di putaran ini",
    "ok": "OK"
    },
  uz:{
    "nogold": "Yeterli miqdorda oltin tanga yo'q",
    "networkout": "Tarmoq vaqtidan oshdi, iltimos, natijani tekshirish uchun tarixga o'ting!",
    "rank": "Reyting",
    "history": "Tarixiy yozuv",
    "rule": "Qoidalar",
    "round": "Davr",
    "winfruit": "G'alaba toshi",
    "selfruit": "Tanlangan tosh",
    "goldNum": "Tikish toshi",
    "gain": "Olingan tosh",
    "ruleContent":
        "1. Foydalanuvchi 5 ta toshdan birini tanlab tikadi<br/>" +
        "2. To'g'ri toshni taxmin qilgan foydalanuvchi, ushbu davrdagi jami tikilgan oltin tangalarning 90%ini oladi<br/>" +
        "3. Agar bir nechta foydalanuvchi bir vaqtning o'zida toshni taxmin qilsa, barcha oltin tangalar 90%i tikilgan oltin tangalar miqdoriga qarab taqsimlanadi<br/>" +
        "4. Agar faqat 1 foydalanuvchi o'yinda ishtirok etsa, joriy davrda o'yin yaroqsiz hisoblanadi, foydalanuvchining asl tikish miqdori qaytariladi, reyting ballari hisobga olinmaydi.",
    "invalid": "Yagona tikish yaroqsiz, 11 oltin tanga qaytarildi",
    "gainGold": "Siz ushbu davrda ...<img src='/img/activity/lottery/jb.png'> oltin tanga oldingiz",
    "ok": "OK"
},
  ru:{
    "nogold": "Недостаточно золотых монет",
    "networkout": "Время ожидания сети истекло, пожалуйста, перейдите в историю, чтобы проверить результат!",
    "rank": "Рейтинг",
    "history": "Историческая запись",
    "rule": "Правила",
    "round": "Раунд",
    "winfruit": "Выигравший камень",
    "selfruit": "Выбранный камень",
    "goldNum": "Ставка камня",
    "gain": "Полученный камень",
    "ruleContent":
        "1. Пользователь выбирает один из 5 камней для ставки<br/>" +
        "2. Пользователь, который правильно угадает камень, получит 90% от общего количества золотых монет, ставленных в этом раунде<br/>" +
        "3. Если несколько пользователей одновременно угадают камни, 90% всех золотых монет будет разделено пропорционально ставкам<br/>" +
        "4. Если только 1 пользователь участвует в игре, текущий раунд игры считается недействительным, и исходная ставка пользователя будет возвращена, баллы рейтинга не начисляются.",
    "invalid": "Одинарная ставка недействительна, 11 золотых монет было возвращено",
    "gainGold": "Вы получили ...<img src='/img/activity/lottery/jb.png'> золотых монет в этом раунде",
    "ok": "OK"
},
    fa:{
    "nogold": "تعداد سکه‌های طلا کافی نیست",
    "networkout": "اتصال شبکه قطع شده است، لطفاً به تاریخچه بروید و نتیجه را بررسی کنید!",
    "rank": "رتبه بندی",
    "history": "سوابق تاریخچه",
    "rule": "قوانین",
    "round": "دور",
    "winfruit": "گوهر برنده",
    "selfruit": "گوهر انتخابی",
    "goldNum": "گوهر شرط‌بندی",
    "gain": "گوهر به دست آمده",
    "ruleContent":
        "1. کاربر یکی از 5 گوهر را برای شرط‌بندی انتخاب می‌کند<br/>" +
        "2. کاربری که گوهر را به درستی حدس بزند، 90% از مجموع سکه‌های طلا شرط‌بندی شده در این دور را دریافت خواهد کرد<br/>" +
        "3. اگر چندین کاربر همزمان گوهرها را حدس بزنند، 90% از تمام سکه‌های طلا بر اساس نسبت سکه‌های شرط‌بندی شده تقسیم خواهد شد<br/>" +
        "4. اگر فقط یک کاربر در بازی شرکت کند، دور فعلی بازی بی‌اعتبار است و مبلغ اصلی شرط کاربر بازگردانده می‌شود، امتیاز رتبه‌بندی محاسبه نخواهد شد.",
    "invalid": "شرط تنها بی‌اعتبار است، 11 سکه طلا بازگشت داده شد",
    "gainGold": "شما در این دور ...<img src='/img/activity/lottery/jb.png'> سکه طلا دریافت کرده‌اید",
    "ok": "تایید"
}






}



// WEBPACK FOOTER //
// src/pages/activity/lottery/lang.js